/**
 * Where a consumption came from. The API exposes the values without names, so
 * only the two confirmed by the business are named here; anything else is
 * surfaced as "other origin" rather than guessed at.
 */
export enum ConsumptionOriginEnum {
  System = 1,
  Manual = 2,
}
